import { render, staticRenderFns } from "./ChangeRoomMenu.vue?vue&type=template&id=56162340&scoped=true&"
import script from "./ChangeRoomMenu.vue?vue&type=script&lang=js&"
export * from "./ChangeRoomMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56162340",
  null
  
)

export default component.exports